import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import haveli1 from "../Images/ga3.jpg";
import haveli2 from "../Images/inter.jpg";
import haveli3 from "../Images/ga4.jpg";
import haveli4 from "../Images/goals.jpeg";
import haveli5 from "../Images/haveli5.jpg"
import haveli6 from "../Images/opentosky.jpg";
import haveli7 from "../Images/mesum.jpeg";
import haveli8 from "../Images/meu1.jpg";
import haveli9 from "../Images/h8.jpeg";
import haveli10 from "../Images/alfresco-views.jpg";
import haveli11 from "../Images/mix-fruit-punch.jpg";
import haveli12 from "../Images/photo0jpg.jpg";
import haveli13 from "../Images/view-of-badshahi-mosque.jpg";
import haveli14 from "../Images/this-is-the-view-of-badshahi.jpg";
import haveli15 from "../Images/exter.jpg";
import haveli16 from "../Images/ga1.jpg";


import MainNav from "../Components/MainNav";
import Footer from "../Components/Footer";
import CustomNavbar from "../Components/CustomNavbar";


const images = [
  haveli1,
  haveli2,
  haveli3,
  haveli4,
  haveli5,
  haveli6,
  haveli7,
  haveli8,
  haveli9,
  haveli10,
  haveli11,
  haveli12,
  haveli13,
  haveli14,
  haveli15,
  haveli16,
];

const PhotoGellary = () => {
  const [scroll, setScroll] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScroll(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="photo-galry-wrapper">
      <MainNav/>
    <Container fluid className="parallax-container mt-5">
      <Row className="parallax-section">
        <h2 className="gallery-title">Image Gallery</h2>
        <Col className="parallax-images">
          {images.map((img, idx) => (
            <div
              key={idx}
              className={`gallery-item ${idx % 3 === 1 ? "parallax-effect" : ""}`}
              style={{ height: idx % 2 === 0 ? "250px" : "300px", transform: idx % 3 === 1 ? `translateY(${scroll * -0.1}px)` : "none" }}
            >
              <img src={img} alt={`Gallery ${idx}`} />
            </div>
          ))}
        </Col>
      </Row>
    </Container>
    <Footer/>
    </div>
  );
};

export default PhotoGellary;